module.exports = __webpack_public_path__ + "img/Group-32714-1-1-2.3531f41b.png";